import { EntityReadEntityContainer } from 'labstep-web/containers/Entity/Read/Entity';
import { TextLink } from 'labstep-web/core/DataGrid/Text/Link';
import type { ResourceItemCellRendererProps } from 'labstep-web/grid/SmartTableProtocolValue/components/CellRenderer/types';
import { ResourceItem } from 'labstep-web/models/resource-item.model';
import { ResourceItemShowCenterContentSecondaryInfo } from 'labstep-web/screens/ResourceItem/Show/Center/SecondaryInfo';
export const ResourceItemCellRenderer: React.FC<
  ResourceItemCellRendererProps
> = ({ protocolValue, resourceItemId, actionIconProps }) => {
  return (
    <EntityReadEntityContainer
      entityName={ResourceItem.entityName}
      id={resourceItemId}
    >
      {({ entity: resourceItem }) => {
        if (!resourceItem) {
          return null;
        }

        return (
          <div>
            <TextLink
              entity={resourceItem}
              entityPreviewProps={{
                secondaryInfo: (
                  <ResourceItemShowCenterContentSecondaryInfo
                    resourceItem={resourceItem}
                  />
                ),
              }}
              actionIconProps={
                protocolValue.is_input &&
                protocolValue.amount_deducted &&
                protocolValue.amount_deducted !== '0'
                  ? actionIconProps
                  : undefined
              }
              disabled
            />
          </div>
        );
      }}
    </EntityReadEntityContainer>
  );
};
